/**
 * Prominent banner when session assessment draft has unsaved edits (Phase 4.3).
 */

export interface SessionAssessmentUnsavedBannerProps {
  dirtyCount: number;
  className?: string;
}

export function SessionAssessmentUnsavedBanner({
  dirtyCount,
  className = '',
}: SessionAssessmentUnsavedBannerProps) {
  if (dirtyCount <= 0) return null;

  return (
    <div
      role="status"
      className={`mb-4 flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 ${className}`}
    >
      <span className="inline-block h-2 w-2 flex-shrink-0 rounded-full bg-amber-500" aria-hidden />
      <span>
        <span className="font-semibold">Unsaved changes</span>
        {' — '}
        {dirtyCount} row{dirtyCount === 1 ? '' : 's'} modified. Save all changes or Cancel before
        leaving this page.
      </span>
    </div>
  );
}
